import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import '@/assets/css/tailwind.pcss'
import '@/assets/css/main.pcss'
import i18n from './i18n'
import { focus } from "vue-focus";
import store from './store/index'


Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  let language = to.params.lang;
  if(!language) {
    language = 'en'
  }
  i18n.locale = language
  next()
})

Vue.directive("hotspot", {
  bind: function (el, binding) {
    el.style.top = `${binding.value.top}%`;
    el.style.left = `${binding.value.left}%`;
    el.style.right = `${binding.value.right}%`;
  }
});

Vue.directive(focus)

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
